module.exports = __webpack_public_path__ + "static/media/mobileSecondFrame.a8badb26.png";